export const URL_BROWSE = 'browse';
export const URL_BROWSE3 = 'browse3';
export const URL_WANDB = 'wandb';

export function urlEntity(entityName: string): string {
  return `/${URL_BROWSE}/${URL_WANDB}/${entityName}`;
}

export function urlProject(entityName: string, projectName: string): string {
  const encodedName = encodeURIComponent(projectName);
  return `${urlEntity(entityName)}/${encodedName}`;
}
